import { render, staticRenderFns } from "./c-pagination-test@.vue?vue&type=template&id=5c3f5572&"
import script from "./c-pagination-test@.vue?vue&type=script&lang=ts&"
export * from "./c-pagination-test@.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports